import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IWorkOrder } from "../pages/master/models/workorder.model";
import { BASE_URL, END_POINTS } from "../utility/APIConstants";
import { environment } from '../../environments/environment';
import { formatDate } from '@angular/common';

@Injectable({ providedIn: 'root' })
export default class WorkOrderService {
    constructor(private _http: HttpClient) { }
    public selectedWorkOrder: IWorkOrder = null;
    public importedWorkOrderData: any = null;
    public fetchWorkOrders(): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.WORK_ORDER.FETCH);
    }

    getWorkOrdersByPageCount(params = {}): Observable<any> {
        return this._http.get<any>(`${environment.apiBase}/workorder/all/bypagination`, { params });
    }

    public fetchApprovedWorkOrders(): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.WORK_ORDER.FETCH_APPROVED);
    }

    public fetchApprovedWorkOrdersBySiteKey(id): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.WORK_ORDER.FETCH_APPROVED_BY_ID(id));
    }

    public fetchWorkOrdersById(id): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.WORK_ORDER.FETCH_BY_ID(id));
    }

    public fetchWoCodeForContractorById(id): Observable<any> {
        return this._http.get<any>(`${environment.apiBase}/workorder/details-scwo/${id}`);
    }

    public fetchWorkOrdersBySiteKey(siteKey): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.WORK_ORDER.FETCH_BY_SITEKEY(siteKey));
    }

    public getWOBySiteForSitePlanning(siteKey: any): Observable<any> {
        return this._http.get<any>(`${environment.apiBase}/workorder/all/bypagination?siteKey=${siteKey}`);
    }



    public fetchWorkOrdersForSiteBudget(siteKey): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.WORK_ORDER.FETCH_FOR_SITEBUDGET(siteKey));
    }

    public fetchWorkOrdersBySiteKeyBOQDone(siteKey): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.WORK_ORDER.FETCH_BY_SITE_BOQ_CREATE_WO(siteKey));
    }

    public createWorkOrder(payload): Observable<any> {
        return this._http.post(BASE_URL + END_POINTS.WORK_ORDER.CREATE, payload);
    }
    public updateWorkOrder(id, payload): Observable<any> {
        return this._http.put(BASE_URL + END_POINTS.WORK_ORDER.UPDATE(id), payload);
    }
    public fetchAmendment(): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.WORK_ORDER.GET_AMENDMENT);
    }

    getWOAmendmentByPageCount(params = {}): Observable<any> {
        return this._http.get<any>(`${environment.apiBase}/workorder/amendmend/all/bypagination`, { params });
    }

    public fetchAmendmentById(id): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.WORK_ORDER.AMENDMENT_BY_ID(id));
    }
    public createAmendment(payload): Observable<any> {
        return this._http.put(BASE_URL + END_POINTS.WORK_ORDER.CREATE_AMENDMENT, payload);
    }
    public addAmendment(id, payload): Observable<any> {
        return this._http.post(BASE_URL + END_POINTS.WORK_ORDER.UPDATE_AMENDMENT(id), payload);
    }

    public updateAmendment(id, payload): Observable<any> {
        return this._http.put(BASE_URL + END_POINTS.WORK_ORDER.UPDATE_AMENDMENT(id), payload);
    }
    public deleteWorkOrder(id): Observable<any> {
        return this._http.delete(BASE_URL + END_POINTS.WORK_ORDER.DELETE(id));
    }
    public importWorkOrder({ file, site, orderDate, workOrderNumber, projectType, gstPercentage }: {
        file: any;
        site: any;
        orderDate: any;
        workOrderNumber: any;
        projectType: any;
        gstPercentage?: any;
    }): Observable<any> {
        const formData = new FormData();
        if (file) {
            formData.append('file', file, file.name);
        }

        const options = {
            responseType: 'blob' as 'json',
            observe: 'response' as 'response'
        };

        const formattedOrderDate = orderDate
            ? formatDate(orderDate, 'yyyy-MM-dd', 'en-US')
            : null;

        const params: any = formattedOrderDate
            ? { orderDate: formattedOrderDate, workOrderNumber, projectType }
            : { workOrderNumber, projectType };

        if (gstPercentage !== undefined && gstPercentage !== null) {
            params.gstPercentage = gstPercentage;
        }

        return this._http.post(BASE_URL + END_POINTS.WORK_ORDER.UPLOAD(site), formData, { ...options, params });
    }

    /**
     * @description API to approve Work Order
     * @param id
     */
    public approveWorkOrder(id: number) {
        return this._http.put(BASE_URL + END_POINTS.WORK_ORDER.APPROVE(id), {});
    }
    /**
     * @description API to reject Work Order
     * @param id
     */
    public rejectWorkOrder(id: number, payload: any) {
        return this._http.put(BASE_URL + END_POINTS.WORK_ORDER.REJECT(id), payload);
    }

    public rejectWorkOrderAmendment(id: number, payload: any) {
        return this._http.put(BASE_URL + END_POINTS.WORK_ORDER.AMENDMENT_REJECT(id), payload);
    }
    public approveWorkOrderAmendment(id: number) {
        return this._http.put(BASE_URL + END_POINTS.WORK_ORDER.AMENDMENT_APPROVE(id), {});
    }
    public printWorkOrder(id: number) {
        return this._http.get(BASE_URL + END_POINTS.WORK_ORDER.PRINT(id), { responseType: 'blob' });
    }

    getWOForProforma(id): Observable<any> {
        return this._http.get<any>(`${environment.apiBase}/workorder/for-prof-inv?siteKey=${id}&workOrderKey=0`,);
    }

    getWODetailsForProforma(id): Observable<any> {
        return this._http.get<any>(`${environment.apiBase}/workorder/for-prof-inv?siteKey=0&workOrderKey=${id}`,);
    }

    changeWoClosingStatus(id, closingStatus): Observable<any> {
        return this._http.put<any>(`${environment.apiBase}/workorder/${id}/status?closingStatus=${closingStatus}`, {});
    }

    //DLP
    public saveProjectContractDetails(workOrderId: number, payload: any): Observable<any> {
        return this._http.post(
            `${environment.apiBase}/workorder/create/${workOrderId}/contract-details`,
            payload
        );
    }

    // Fetch existing DLP record by workorder ID
    getDlpByWorkorderId(workOrderId: number): Observable<any> {
        return this._http.get(
            `${environment.apiBase}/api/project-contract-details/workorder/${workOrderId}/single`
        );
    }

    // Update existing DLP record
    updateProjectContractDetails(id: number, payload: any): Observable<any> {
        return this._http.put(
            `${environment.apiBase}/api/project-contract-details/${id}`,
            payload
        );
    }

    getPreviousAmendedQty(workOrderKey: string | number, workOrderDetailKey: string | number): Observable<number> {
        return this._http.get<number>(`${environment.apiBase}/workorder/amendmend/previous-qty`, {
            params: { workOrderKey: workOrderKey.toString(), workOrderDetailKey: workOrderDetailKey.toString() }
        });
    }

    public fetchWorkOrdersByIdSitePlanning(
        id: number
    ): Observable<any> {

        return this._http.get(
            `${environment.apiBase}/workorder/get-siteplanning/${id}`
        );

    }

    // src/app/services/WorkOrder.ts

getPaymentTermsForSitc(workOrderKey: number): Observable<any[]> {
  return this._http.get<any[]>(`${environment.billingApiBase}/sitc/payment-terms/${workOrderKey}`);
}

// WorkOrderService
getWorkOrderDetails(workOrderKey: number): Observable<any> {
  return this._http.get<any>(`${environment.apiBase}/workorder/details/${workOrderKey}`);
}


}


